"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var Observable_1 = require("rxjs/Observable");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var header_settings_component_1 = require("./settings/header-settings.component");
var router_1 = require("@angular/router");
var operators_1 = require("rxjs/operators");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_lock_service_client_js_1 = require("@synisys/idm-lock-service-client-js");
var common_1 = require("@angular/common");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var http_1 = require("@angular/common/http");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var entity_name_provider_service_1 = require("../../../../../shared/services/api/entity-name-provider.service");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var static_method_1 = require("../../../../../shared/utils/static-method");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var meta_knowledge_provider_service_1 = require("../../../../../shared/services/api/meta-knowledge-provider.service");
var from_1 = require("rxjs/observable/from");
var of_1 = require("rxjs/observable/of");
var custom_header_action_service_1 = require("../../../../../shared/services/api/custom-header-action.service");
var custom_header_action_1 = require("../../../../../shared/model/custom-header-action");
var root_category_provider_service_1 = require("../../../../../shared/services/api/root-category-provider.service");
var form_resolution_service_1 = require("../../../../../shared/services/api/form-resolution.service");
var url_and_query_params_1 = require("../../../../../shared/utils/url-and-query-params");
var dynamic_navigation_helper_1 = require("../../../common/utils/dynamic-navigation-helper");
var Subject_1 = require("rxjs/Subject");
var summary_pages_navigation_prefix_1 = require("../../summary-pages-navigation-prefix");
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(route, router, location, currentLanguageProvider, localeService, lockService, applicationPropertiesService, http, eventBase, formResolutionService, kbService, classifierService, entityNameProviderService, rootCategoryProviderService, authorizationService, sessionDataProvider, actionService, metaKnowledgeProviderService, navigationPrefix, customHeaderActionService) {
        this.route = route;
        this.router = router;
        this.location = location;
        this.currentLanguageProvider = currentLanguageProvider;
        this.localeService = localeService;
        this.lockService = lockService;
        this.applicationPropertiesService = applicationPropertiesService;
        this.http = http;
        this.eventBase = eventBase;
        this.formResolutionService = formResolutionService;
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.entityNameProviderService = entityNameProviderService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.authorizationService = authorizationService;
        this.sessionDataProvider = sessionDataProvider;
        this.actionService = actionService;
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        this.navigationPrefix = navigationPrefix;
        this.customHeaderActionService = customHeaderActionService;
        this.isView = false;
        this.isReadonly = false;
        this.workflowActions = [];
        this.actions = null;
        this.quickStartCategories = [];
        this.onWfSelect = new core_1.EventEmitter();
        this.cancelEvent = new core_1.EventEmitter();
        this.saveEvent = new core_1.EventEmitter();
        this.saveCloseEvent = new core_1.EventEmitter();
        this.saveAndClosedClicked = false;
        this.saveAndSignClicked = false;
        this.destroy$ = new Subject_1.Subject();
    }
    HeaderComponent_1 = HeaderComponent;
    Object.defineProperty(HeaderComponent.prototype, "userHelpItemsAsObjects", {
        set: function (values) {
            this.userHelpItems = (values && this.form && !this.form.inDrawer) ? values.map(idm_dynamic_forms_controls_1.userHelpItemFromObject) : [];
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.isActionSaveSuccessfully = function (saveEventData) {
        var serviceResponse = saveEventData && saveEventData.data;
        return saveEventData.key === idm_dynamic_forms_ui_1.ActionNotifierKey.SAVE_ACTION && serviceResponse
            && serviceResponse.getMeta()
            && serviceResponse.getMeta().getValidationErrors().length === 0;
    };
    HeaderComponent.isActionSaveNoModification = function (saveEventData) {
        var serviceResponse = saveEventData && saveEventData.data;
        return saveEventData.key === idm_dynamic_forms_ui_1.ActionNotifierKey.SAVE_ACTION && serviceResponse && !serviceResponse.getMeta();
    };
    HeaderComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (this.entity) {
            if (!this.signedCopyGenerationReady$) {
                this.signedCopyGenerationReady$ = this.eventBase.listen('generate-signed-copy-document-ready').pipe(operators_1.publishReplay(1), operators_1.refCount(), operators_1.switchMap(function (event) {
                    return event.data
                        ? _this.metaKnowledgeProviderService.getSignedCopyDocumentDefinitions(_this.categoryName)
                        : Observable_1.Observable.of(void 0);
                }));
            }
            // initialize information based on entity data.
            if (changes.entity) {
                this.initRequiredInformation();
                this.initCustomActions();
            }
            if (changes.validations && this.validations.length) {
                this.updateIsReadyForGeneratingNumber(false);
            }
        }
    };
    HeaderComponent.prototype.updateIsReadyForGeneratingNumber = function (value) {
        if (!this.entity.getInstanceId() && this.entity.hasProperty('isReadyForGeneratingNumber')) {
            this.entity.getProperty('isReadyForGeneratingNumber').value = value;
        }
    };
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.entity) {
            this.actionNotifier && this.actionNotifier
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe(function (saveEventData) {
                if (HeaderComponent_1.isActionSaveSuccessfully(saveEventData) ||
                    HeaderComponent_1.isActionSaveNoModification(saveEventData)) {
                    _this.onSaveAction();
                }
            });
        }
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    HeaderComponent.prototype.getIsView = function () {
        return this.isView !== undefined ? this.isView : this.isReadonly;
    };
    HeaderComponent.prototype.onWorkflowEvent = function (wfActionId) {
        this.onWfSelect.emit(wfActionId);
    };
    HeaderComponent.prototype.onEditEvent = function () {
        var _this = this;
        if (this.entity) {
            this.formResolutionService.getEntityFormProperties(this.categoryName, this.entity.getInstanceId(), this.entity)
                .pipe(operators_1.take(1))
                .subscribe(function (properties) { return _this.actions['toEdit'](_this.form, properties.editFormName, _this.categoryName, _this.entity.getInstanceId(), properties.editFormId); });
        }
    };
    HeaderComponent.prototype.onDuplicateEvent = function (rootCategoryId, rootEntityId) {
        var _this = this;
        this.formResolutionService.getEntityFormProperties(this.categoryName, this.entity.getInstanceId(), this.entity).pipe(operators_1.switchMap(function (formProperties) {
            var params = new Map()
                .set(url_and_query_params_1.UrlAndQueryParams.isAutofill, true)
                .set(url_and_query_params_1.UrlAndQueryParams.duplicateEntityId, _this.entity.getInstanceId());
            return dynamic_navigation_helper_1.navigateToCreateForm(_this.navigationPrefix, rootCategoryId, rootEntityId, _this.categoryName, formProperties.editFormName, formProperties.editFormId, _this.route, _this.router, params);
        }), operators_1.take(1)).subscribe();
    };
    HeaderComponent.prototype.onSaveEvent = function () {
        this.saveAndClosedClicked = false;
        this.saveAndSignClicked = false;
        this.updateIsReadyForGeneratingNumber(true);
        this.saveEvent.emit();
    };
    HeaderComponent.prototype.onSaveCloseEvent = function () {
        this.saveAndClosedClicked = true;
        this.saveAndSignClicked = false;
        this.updateIsReadyForGeneratingNumber(true);
        this.saveEvent.emit();
    };
    HeaderComponent.prototype.onSaveSignEvent = function () {
        this.saveAndClosedClicked = false;
        this.saveAndSignClicked = true;
        this.updateIsReadyForGeneratingNumber(true);
        this.saveEvent.emit();
    };
    HeaderComponent.prototype.onBackEvent = function () {
        if (this.form.inDrawer) {
            this.cancelEvent.emit();
        }
        else {
            this.location.back();
        }
    };
    HeaderComponent.prototype.onCancelEvent = function () {
        var _this = this;
        if (this.entity) {
            if (this.entity.getInstanceId() && !this.form.inDrawer) {
                this.formResolutionService.getEntityFormProperties(this.categoryName, this.entity.getInstanceId(), this.entity).pipe(operators_1.tap(function (formProperties) {
                    _this.actions['toView'](_this.form, formProperties.viewFormName, _this.categoryName, _this.entity.getInstanceId(), formProperties.viewFormId);
                }), operators_1.take(1)).subscribe();
            }
            else {
                this.onBackEvent();
            }
        }
    };
    HeaderComponent.prototype.onCustomActionEvent = function (functionId) {
        var _this = this;
        if (functionId === 'onDuplicateEvent') {
            this.rootCategoryId$.pipe(operators_1.switchMap(function (rootCategoryId) {
                return _this.rootEntityId$.pipe(operators_1.map(function (rootEntityId) {
                    _this.onDuplicateEvent(rootCategoryId, rootEntityId);
                }));
            }), operators_1.take(1)).subscribe();
        }
        else {
            if (this.customHeaderActionService) {
                this.customHeaderActionService.doAction({
                    functionId: functionId,
                    entity: this.entity,
                    form: this.form
                });
            }
        }
    };
    HeaderComponent.prototype.onPayOnlineEvent = function () {
        var _this = this;
        this.rootCategoryId$
            .pipe(operators_1.switchMap(function (rootCategoryId) { return _this.metaKnowledgeProviderService.getPaymentDefinitions(rootCategoryId); }))
            .subscribe(function (paymentDefinitions) {
            if (paymentDefinitions) {
                var url = _this.entity.getProperty(paymentDefinitions.externalPaymentUrl).value;
                window.open(url, "_blank");
            }
        });
    };
    HeaderComponent.prototype.onSaveAction = function () {
        var _this = this;
        if (this.saveAndClosedClicked) {
            this.saveAndClosedClicked = false;
            if (!this.form.inDrawer) {
                this.rootCategoryId$.pipe(operators_1.switchMap(function (rootCategoryId) {
                    return _this.rootEntityId$.pipe(operators_1.switchMap(function (value) {
                        var rootEntityId$ = _this.rootCategoryProviderService.getRootEntityId(rootCategoryId, _this.categoryName, _this.entity);
                        return (value ? Observable_1.Observable.of(value) : rootEntityId$).pipe(operators_1.tap(function (rootEntityId) {
                            _this.onCategorySaveAndClosed(rootCategoryId, rootEntityId);
                        }));
                    }));
                }), operators_1.take(1)).subscribe();
            }
            else {
                this.cancelEvent.emit();
            }
        }
        else if (this.saveAndSignClicked) {
            this.saveAndSignClicked = false;
            if (!this.form.inDrawer) {
                this.eventBase.publish('generate-signed-copy-document', {});
            }
        }
    };
    HeaderComponent.prototype.onCategorySaveAndClosed = function (rootCategoryId, rootEntityId) {
        var _this = this;
        this.lockService.removeLock(this.categoryName, this.entity.getInstanceId()).pipe(operators_1.switchMap(function () {
            return _this.formResolutionService.getEntityFormProperties(_this.categoryName, _this.entity.getInstanceId(), _this.entity).pipe(operators_1.switchMap(function (formProperties) {
                return dynamic_navigation_helper_1.navigateToForm(_this.navigationPrefix, rootCategoryId, rootEntityId, _this.categoryName, _this.entity.getInstanceId(), formProperties.viewFormName, formProperties.viewFormId, _this.route, _this.router);
            }));
        }), operators_1.take(1)).subscribe();
    };
    HeaderComponent.prototype.initRequiredInformation = function () {
        var _this = this;
        this.rootCategoryId$ = this.rootCategoryProviderService.getRootCategoryId(this.categoryName);
        this.rootEntityId$ = this.rootCategoryId$.pipe(operators_1.switchMap(function (rootCategoryId) { return _this.rootCategoryProviderService.getRootEntityId(rootCategoryId, _this.categoryName, _this.entity); }), operators_1.publishReplay(1), operators_1.refCount());
        this.wfStateName$ = this.getWFStateName().publishReplay(1).refCount();
        this.entityName$ = this.getEntityName();
        this.rootEntityName$ = this.getRootEntityName();
        this.isChildCategoryForm$ = this.rootCategoryId$.pipe(operators_1.map(function (rootCategoryId) { return rootCategoryId && rootCategoryId !== _this.categoryName; }));
    };
    HeaderComponent.prototype.initCustomActions = function () {
        this.customHeaderMenuActions = [];
        this.customHeaderButtonActions = [];
        this.addPaymentAction();
        this.addDuplicateAction();
        this.addCustomActions();
        this.addSaveAndSignAction();
    };
    HeaderComponent.prototype.addPaymentAction = function () {
        var _this = this;
        if (this.isReadonly) {
            this.hasPaymentButton$ = this.kbService.getWorkflowStateMetaField(this.categoryName).pipe(operators_1.switchMap(function (wfStateField) {
                if (wfStateField) {
                    return _this.rootCategoryId$.pipe(operators_1.switchMap(function (rootCategoryId) { return _this.metaKnowledgeProviderService.getPaymentDefinitions(rootCategoryId); }), operators_1.switchMap(function (paymentDefinitions) {
                        if (paymentDefinitions && wfStateField) {
                            var wfStateId = _this.entity.getProperty(wfStateField.getSystemName()).value.getId();
                            return from_1.from(_this.actionService.getActionsByStateId(wfStateId)).pipe(operators_1.map(function (userActions) { return userActions.some(function (action) { return action.getId() === paymentDefinitions.paidActionId; }); }));
                        }
                        else {
                            return of_1.of(false);
                        }
                    }));
                }
                return of_1.of(void 0);
            }));
        }
    };
    HeaderComponent.prototype.addSaveAndSignAction = function () {
        this.hasSaveSignButton$ = this.getIsView() || this.form.inDrawer || !this.signedCopyGenerationReady$
            ? Observable_1.Observable.of(false)
            : this.signedCopyGenerationReady$
                .pipe(operators_1.map(function (value) { return !!(value && value.fieldId && value.templates && value.templates.length); }));
    };
    HeaderComponent.prototype.addDuplicateAction = function () {
        var _this = this;
        if (this.showCloneButton) {
            this.sessionDataProvider.getCurrentUserData()
                .pipe(operators_1.switchMap(function (currentUserData) {
                return _this.authorizationService.getCategoryPermissionsValues({
                    userId: currentUserData.userId,
                    categorySystemNames: [_this.categoryName],
                    workflowStateId: null,
                    permissionType: idm_authorization_client_js_1.PermissionType.ADD,
                    conditionalPermissionValues: null
                });
            }), operators_1.take(1), operators_1.takeUntil(this.destroy$))
                .subscribe(function (value) {
                var hasCreatePermission = static_method_1.hasPermission(value.get(_this.categoryName));
                if (hasCreatePermission) {
                    if (!_this.customHeaderMenuActions.find(function (action) { return action.functionId === 'onDuplicateEvent'; })) {
                        _this.customHeaderMenuActions.push({ messageKey: 'ejustice_duplicate', functionId: 'onDuplicateEvent' });
                    }
                }
            });
        }
    };
    HeaderComponent.prototype.addCustomActions = function () {
        var _this = this;
        if (this.customHeaderActionService) {
            this.customHeaderActionService.getActions(this.categoryName, this.entity)
                .pipe(operators_1.take(1), operators_1.takeUntil(this.destroy$))
                .subscribe(function (actions) {
                actions.forEach(function (action) {
                    var customHeaderAction = __assign({}, action);
                    switch (action.type) {
                        case custom_header_action_1.CustomHeaderActionType.MENU:
                            if (!_this.customHeaderMenuActions.find(function (value) { return value.functionId === customHeaderAction.functionId; })) {
                                _this.customHeaderMenuActions.push(customHeaderAction);
                            }
                            break;
                        case custom_header_action_1.CustomHeaderActionType.BUTTON:
                            if (!_this.customHeaderButtonActions.find(function (value) { return value.functionId === customHeaderAction.functionId; })) {
                                _this.customHeaderButtonActions.push(customHeaderAction);
                            }
                            break;
                    }
                });
            });
        }
    };
    HeaderComponent.prototype.getEntityName = function () {
        if (this.entity.getInstanceId()) {
            return this.entityNameProviderService.getEntityName(this.categoryName, this.entity.getInstanceId(), this.entity);
        }
        return Observable_1.Observable.of(null);
    };
    HeaderComponent.prototype.getRootEntityName = function () {
        var _this = this;
        return this.rootCategoryId$.pipe(operators_1.switchMap(function (rootCategoryId) {
            return _this.rootEntityId$.pipe(operators_1.switchMap(function (rootEntityId) {
                return _this.entityNameProviderService.getEntityName(rootCategoryId, rootEntityId);
            }));
        }));
    };
    HeaderComponent.prototype.getWFStateName = function () {
        var _this = this;
        return this.kbService.getMetaFields(this.categoryName).pipe(operators_1.switchMap(function (fields) {
            var wfStateField = fields.find(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE; });
            if (wfStateField) {
                return _this.classifierService.getEntityName(wfStateField.getCompoundCategorySystemName(), _this.entity.getProperty(wfStateField.getSystemName()).value);
            }
            return Observable_1.Observable.of(null);
        }));
    };
    var HeaderComponent_1;
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.EntityDefault)
    ], HeaderComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "isView", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "caption", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "titleMsg", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "userHelpItems", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderComponent.prototype, "userHelpItemsAsObjects", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "exportTemplates", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "workflowActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HeaderComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "labelMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "hasEditPermission", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "withDeleteButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "withEditButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "withCommentButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], HeaderComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "actions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "formActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderComponent.prototype, "transientFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "showCloneButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "quickStartCategories", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HeaderComponent.prototype, "validations", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "onWfSelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "cancelEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "saveEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderComponent.prototype, "saveCloseEvent", void 0);
    HeaderComponent = HeaderComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-header',
            styles: [require('./header.component.css')],
            template: require('./header.component.html')
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'EJustice Header',
            nameKey: 'ejustice_header_control',
            template: "\n        <ejustice-header\n            [id]=\"'%{id}'\"\n            [entity]=\"entity\"\n            [categoryName]=\"category\"\n            [isView]=\"actions.isViewForm()\"\n            [caption]=\"category\"\n            [form]=\"form\"\n            [actions]=\"actions\"\n            [formActions]=\"actions\"\n            [userHelpItemsAsObjects]=\"%{userHelpItems}\"\n            [exportTemplates]=\"%{exportTemplates}\"\n            [workflowActions]=\"workflowActions\"\n            [currentLanguageId]=\"currentLanguageId\"\n            [labelMessage]=\"%{labelMessage}\"\n            [titleMsg]=\"%{title_msg}\"\n            [withDeleteButton]=\"%{withDeleteButton}\"\n            [withEditButton]=\"%{withEditButton}\"\n            [withCommentButton]=\"%{withCommentButton}\"\n            [actionNotifier]=\"actionNotifier\"\n            [hasEditPermission]=\"%{hasEditPermission}\"\n            [validations]=\"validations\"\n            [isReadonly]=\"%{isReadonly}\"\n            [transientFields]=\"transientFields\"\n            [quickStartCategories]=\"%{quickStartCategories}\"\n            [showCloneButton]=\"%{showCloneButton}\"\n            (onWfSelect)=\"%{onWfSelect}\"\n            (cancelEvent)=\"%{cancelEvent}\"\n            (saveEvent)=\"%{saveEvent}\"\n            (saveCloseEvent)=\"%{saveCloseEvent}\">\n    </ejustice-header> ",
            defaultActions: {
                'hasEditPermission': 'hasEditPermission',
                'onWfSelect': 'onDoWorkflowAction',
                'cancelEvent': 'onCancel',
                'saveEvent': 'onSave',
                'saveCloseEvent': 'onSaveAndClose'
            },
            settings: {
                main: header_settings_component_1.HeaderSettingsComponent,
            },
            isHeader: true,
            isFieldBound: true,
        }),
        __param(18, core_1.Optional()), __param(18, core_1.Inject(summary_pages_navigation_prefix_1.SUMMARY_PAGES_NAVIGATION_PREFIX)),
        __param(19, core_1.Optional()),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, router_1.Router,
            common_1.Location,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_locale_service_client_js_1.LocaleService,
            idm_lock_service_client_js_1.LockingService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            http_1.HttpClient,
            idm_session_data_provider_api_js_1.EventBase,
            form_resolution_service_1.FormResolutionService,
            idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            entity_name_provider_service_1.EntityNameProviderService,
            root_category_provider_service_1.RootCategoryProviderService,
            idm_authorization_client_js_1.AuthorizationService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            idm_workflow_service_client_js_1.ActionService,
            meta_knowledge_provider_service_1.MetaKnowledgeProviderService, String, custom_header_action_service_1.CustomHeaderActionService])
    ], HeaderComponent);
    return HeaderComponent;
}());
exports.HeaderComponent = HeaderComponent;
//# sourceMappingURL=header.component.js.map